module.exports = __webpack_public_path__ + "static/media/striped_bar_prewash10_tall.8c7dbc1f.svg";